export default __webpack_public_path__ + "static/media/3.34e6ef6a.jpg";